(() => {
  const MAX = 3;
  const TRYON_TEXT = "(In-Home Try On)";

  // ---------- helpers ----------
  function isTryOnItem(item) {
    return (item?.title || "").includes(TRYON_TEXT);
  }

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    return res.json();
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function moveHomeTrialUIToBody() {
    const drawer = document.querySelector(".home-trial-drawer");
    const toast = document.querySelector(".home-trial-toast");

    if (drawer && drawer.parentElement !== document.body) document.body.appendChild(drawer);
    if (toast && toast.parentElement !== document.body) document.body.appendChild(toast);
  }

  // ---------- init (wait for DOM) ----------
  document.addEventListener("DOMContentLoaded", () => {
    moveHomeTrialUIToBody();

    const els = {
      tracker: document.getElementById("HomeTrialTracker"),
      badge: document.querySelector("[data-home-trial-count]"),
      countInline: document.querySelector("[data-home-trial-count-inline]"),
      drawer: document.getElementById("HomeTrialDrawer"),
      list: document.querySelector("[data-home-trial-list]"),
      toast: document.getElementById("HomeTrialToast"),
      toastText: document.querySelector("[data-home-trial-toast-text]"),
    };

    if (!els.drawer) return;

    function setCount(count) {
      if (els.badge) {
        els.badge.hidden = count <= 0;
        els.badge.textContent = String(count);
      }
      if (els.countInline) els.countInline.textContent = String(count);
    }

    function openDrawer() {
      els.drawer.hidden = false;
      document.documentElement.classList.add("home-trial-open");
    }

    function closeDrawer() {
      els.drawer.hidden = true;
      document.documentElement.classList.remove("home-trial-open");
    }

    function showToast(count, anchorBtn) {
  positionToastAtButton(anchorBtn);
      if (!els.toast || !els.toastText) return;
      els.toastText.textContent = `${count} of ${MAX} frames selected.`;
      els.toast.hidden = false;
      clearTimeout(showToast._t);
      showToast._t = setTimeout(() => (els.toast.hidden = true), 3500);
    }
    
    function positionToastAtButton(btn) {
  if (!els.toast || !btn) return;

  const r = btn.getBoundingClientRect();

  // Center the toast above the button
  els.toast.style.position = "fixed";
  els.toast.style.left = `${r.left + r.width / 2}px`;
  els.toast.style.top = `${Math.max(12, r.top - 12)}px`;
  els.toast.style.transform = "translate(-50%, -100%)";
  els.toast.style.zIndex = "9999";
}
    function renderList(tryOnItems) {
      if (!els.list) return;

      if (!tryOnItems.length) {
        els.list.innerHTML = `<div class="home-trial-empty">No frames selected yet.</div>`;
        return;
      }

      els.list.innerHTML = tryOnItems
        .map((item) => {
          const img = item.image || "";
          const name = (item.product_title || item.title || "").replace(TRYON_TEXT, "").trim();
          const variant =
            item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
          const key = item.key; // keep RAW key

          return `
            <div class="home-trial-item">
              <img class="home-trial-item__img" src="${img}" alt="">
              <div>
                <div class="home-trial-item__name">${escapeHtml(name)}</div>
                ${variant ? `<div class="home-trial-item__variant">${escapeHtml(variant)}</div>` : ``}
              </div>
              <button
  class="home-trial-item__remove"
  type="button"
  aria-label="Remove"
  data-home-trial-remove="${key}"
>×</button>
            </div>
          `;
        })
        .join("");
    }

    async function refreshUI({ toast = false } = {}) {
      const cart = await getCart();
      const tryOnItems = (cart.items || []).filter(isTryOnItem);

      // IMPORTANT: count UNIQUE frames (not quantity)
      const count = tryOnItems.length;

      setCount(count);
      renderList(tryOnItems);

      if (toast && count > 0) showToast(count);
    }

    // ✅ THIS is the remove that works most reliably on Shopify: id = line-item key (form-encoded)
   async function removeByKey(rawKey) {
  try {
    const key = String(rawKey || "");

    // 1) Try remove by LINE ITEM KEY (best)
    let res = await fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Accept": "application/json",
      },
      body: new URLSearchParams({ id: key, quantity: "0" }).toString(),
    });

    // 2) If it fails, fallback to LINE removal
    if (!res.ok) {
      const cart = await getCart();
      const idx = (cart.items || []).findIndex((i) => i.key === key);

      if (idx === -1) {
        console.error("[HomeTrial] key not found in /cart.js:", key);
        return;
      }

      const line = String(idx + 1); // 1-based
      res = await fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          "Accept": "application/json",
        },
        body: new URLSearchParams({ line, quantity: "0" }).toString(),
      });
    }

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      console.error("[HomeTrial] remove failed:", res.status, txt);
      return;
    }

    await refreshUI();
  } catch (e) {
    console.error("[HomeTrial] remove exception:", e);
  }
}

    // ✅ Bind remove clicks directly on the list (no theme handler can steal it)
  if (els.list) {
  els.list.addEventListener(
    "click",
    async (e) => {
      const btn = e.target.closest(".home-trial-item__remove");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const key = btn.getAttribute("data-home-trial-remove");
      if (!key) return;

      btn.disabled = true;
      await removeByKey(key);
      btn.disabled = false;
    },
    true // capture phase so nothing steals the click
  );
}

    // Open / Close
    document.addEventListener("click", async (e) => {
      const openBtn = e.target.closest("[data-home-trial-open]");
      const closeBtn = e.target.closest("[data-home-trial-close]");
      const goCart = e.target.closest("[data-home-trial-go-cart]");

      if (openBtn) {
        await refreshUI();
        openDrawer();
      }
      if (closeBtn) closeDrawer();
      if (goCart) window.location.href = "/cart";
    });

    // --- SAFE cart sync (no fetch override) ---
// Refresh when user comes back to the tab (after app/modals)
document.addEventListener("visibilitychange", () => {
  if (!document.hidden) refreshUI();
});

// Refresh after Shopify cart updates via custom events (some themes/apps dispatch these)
document.addEventListener("cart:refresh", refreshUI);
document.addEventListener("cart:updated", refreshUI);

// As a fallback, refresh shortly after any add/remove click on the page
document.addEventListener(
  "click",
  (e) => {
    if (
      e.target.closest('form[action*="/cart/add"] button[type="submit"]') ||
      e.target.closest('a[href*="/cart/change"]') ||
      e.target.closest('button[name="add"]')
    ) {
      setTimeout(() => refreshUI({ toast: true }), 600);
    }
  },
  true
);

    // initial
    refreshUI();
  });
})();